import React from 'react';
import {NavLink} from 'react-router-dom';
import {apiHost} from '../../../common/config';
import store from '../../../store/store';
import Layout from '../../../layouts/authorized';
import Select from '../../../components/UI/Select/Select';
import CustomTable from '../../../components/table/table.2.0';
import './permission.scss';
import axios from 'axios';

class Page extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            responseError: '',
            headers: [
                {code: 'regionalManager', caption: 'Региональный менеджер', type: 'text'},
                {code: 'saleForce', caption: 'Sales Force', type: 'text'},
                {code: 'legalEntity', caption: 'Партнёр', type: 'text'},
                {code: 'invite', caption: 'Приглашение', type: 'text'},
                {code: 'owners', caption: 'Руководители', type: 'number'},
                {code: 'helpers', caption: 'Помощники', type: 'number'},
                {code: 'consultants', caption: 'Консультанты', type: 'number'},
                {code: 'doctors', caption: 'Врачи', type: 'number'},
            ],
            sf: [
                {value: '', label: 'Все'}
            ],
            rm: [
                {value: '', label: 'Все'}
            ],
            tableData: [],
            entities: [
                {value: '', label: 'Все партнёры'}
            ],
            filter: {
                legalEntity: '',
                sf: '',
                rm: '',
                limit: 10,
                page: 1,
            },
            searching: false,
            allRecords: 0
        }
    }

    componentDidMount = () => {
        this.getRegionalManagerUsers();
    };

    getRegionalManagerUsers() {
        axios.get(
            `${apiHost}/user/get/rm/users`,
            {withCredentials: true,}
        ).then(res => {
            const { rm } = this.state;
            this.setState({
                rm: [...rm, ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    getSalesForceUsers() {
        const {filter} = this.state;

        axios.get(
            `${apiHost}/user/get/sf/users/by/rm/${filter.rm}`,
            {withCredentials: true,}
        ).then(res => {
            const { sf } = this.state;
            this.setState({
                sf: [...[{value: '', label: 'Все'}], ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    getEntities() {
        const {filter} = this.state;

        axios.get(
            `${apiHost}/entity/getlist/by/sf/${filter.sf}`,
            {withCredentials: true,}
        ).then(res => {
            const { entities } = this.state;
            this.setState({
                entities: [...[{value: '', label: 'Все партнёры'}], ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    getTableData(filter) {
        axios.get(
            `${apiHost}/activity/get/registered/user/stat`,
            {
                withCredentials: true,
                params: {
                    filter: JSON.stringify(filter)
                }
            }
        ).then(res => {
            this.setState({
                tableData: res.data.data,
                allRecords: res.data.allRecords
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        }).finally(() => {
            this.setState({
                searching: false
            });
        });
    }

    handleChangeEntity(selectedOption) {
        const {filter} = this.state;
        filter.legalEntity = selectedOption.value;
        this.setState({filter});
    }

    handleChangeSalesForce(selectedOption) {
        const {filter} = this.state;
        filter.sf = selectedOption.value;
        this.setState({filter});

        this.checkIfNeedClearInputs('sf');
        this.getEntities();
    }

    handleChangeRegionalManager(selectedOption) {
        const {filter} = this.state;
        filter.rm = selectedOption.value;
        this.setState({filter});

        this.checkIfNeedClearInputs('rm');
        this.getSalesForceUsers();
    }

    handleChangePage = (page) => {
        const {filter} = this.state
        filter.page = page;
        this.setState({
            searching: true
        });

        this.getTableData(filter);
    }

    handleSearch = () => {
        const {filter} = this.state;
        filter.page = 1;

        this.setState({
            searching: true
        });

        this.getTableData(filter);
    }

    checkIfNeedClearInputs = (field) => {
        const {filter} = this.state;

        if (field == 'rm') {
            filter.sf = '';
            filter.legalEntity = '';
        }

        if (field == 'sf') {
            filter.legalEntity = '';
        }

        this.setState({filter});
    }

    render() {
        const {filter} = this.state;

        return (
            <Layout>

                <h2 className="page-title">Статистика по выданным доступам</h2>

                <div className="w-full md:flex md:justify-between md:w-3/4">
                    <div className="md:w-6/12 md:mr-5">
                        <Select
                            name="rm"
                            label="Выберите РМ"
                            placeholder="Все"
                            options={this.state.rm}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeRegionalManager(selectedOption)}
                            isDisabled={this.state.searching}
                        />
                    </div>
                    <div className="md:w-6/12 md:ml-5">
                        <Select
                            name="entity"
                            label="Выберите Sales Force"
                            placeholder="Все"
                            options={this.state.sf}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeSalesForce(selectedOption)}
                            isDisabled={this.state.searching || filter.rm == ''}
                            value={this.state.sf.filter((item) => item.value === filter.sf)}
                        />
                    </div>
                </div>

                <div className="w-full md:flex md:justify-between md:w-3/4">
                    <div className="md:w-6/12 md:mr-5">
                        <Select
                            name="legalEntity"
                            label="Выберите партнёра"
                            placeholder="Все партнёры"
                            options={this.state.entities}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeEntity(selectedOption)}
                            isDisabled={this.state.searching || filter.sf == ''}
                            value={this.state.entities.filter((item) => item.value === filter.legalEntity)}
                        />
                    </div>
                    <div className="md:w-6/12 md:ml-5"></div>
                </div>
                <div className="w-full md:flex md:justify-between md:w-3/4 mb-10 mt-3">
                    <div className="md:w-6/12 md:mr-5">
                        <div className="w-full md:flex md:justify-between">
                            <button disabled={this.state.searching ? "disabled" : ""}
                                    className="btn btn-narrow btn-blue w-full md:w-6/12 md:mr-5"
                                    onClick={this.handleSearch}>Найти</button>

                        </div>
                    </div>

                    <div className="md:w-6/12 md:ml-5"></div>
                </div>

                {  this.state.tableData.length > 0 &&
                <CustomTable
                    headers={this.state.headers}
                    tableData={this.state.tableData}
                    showSpin={this.state.searching}
                    allRecords={this.state.allRecords}
                    perPage={this.state.filter.limit}
                    currentPage={this.state.filter.page}
                    onChangePage={this.handleChangePage}
                    exportLink={`${apiHost}/export/registered/users?filter=${JSON.stringify(this.state.filter)}`}
                />
                }
            </Layout>
        );
    }
}



export default Page;